export const avatarUrl = 'http://localhost:4003/avatar/';
// export const avatarUrl = 'https://rs-pocker-backend-production.up.railway.app/avatar/';
// export const avatarUrl = 'http://inikon.online:4003/avatar/';
// export const avatarUrl = 'https://poker.inikon.online/rest/avatar/';

export const socketUrl = 'ws://localhost:4003';
// export const socketUrl = 'wss://rs-pocker-backend-production.up.railway.app';
// export const socketUrl = 'ws://inikon.online:4003/';
// export const socketUrl = 'wss://poker.inikon.online/ws';



export const delayBetweenRounds = 6000;
export const moveTime = 10000;
export const bonusTime = 120000;
export const bonusChips = 6000;
